module.exports = __webpack_public_path__ + "media/normalswap.27f2aef2.mp4";